import styled from 'styled-components';
import { vw } from 'components/common/Common';
import { H2, P, Link, SvgIcon } from '../Jet.style';

const IntroduceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  padding: 0 ${vw(100)};
  p {
    text-align: center;
  }
`;

const JetTypeContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: fit-content;
  margin: ${vw(50)} 0 ${vw(100)};
  text-align: center;
`;

const JetContent = styled.a`
  height: ${vw(120)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;

const JetSpan = styled.span`
  font-size: ${vw(16)};
  color: #000;
  text-align: center;
  display: block;
  width: ${vw(120)};
  height: fit-content;
  font-weight: 600;
`;

const LinkBox = styled.div`
  display: flex;
  gap: ${vw(20)};
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
`;

export const JetList = [
  'Ultra Long Range Jets',
  'Heavy Jets',
  'Super-Midsize Jets',
  'Midsize Jets',
  'Light Jets',
  'Turboprop Jets',
  'Piston Jets',
];
const Introduce = () => {
  return (
    <IntroduceContainer>
      <H2>Private Jets by Type</H2>
      <P>
        Fly based on your unique needs, not based on whatever’s available.
        <br /> From small private jets to the longest-range private jets, our team knows jets—plain
        and simple.
      </P>
      <JetTypeContainer>
        {JetList.map((jet, index) => {
          return (
            <JetContent key={index} href={`#${encodeURIComponent(jet)}`}>
              <SvgIcon $size={80} src={`/imgs/svg/jet/Jet-${index}.svg`} alt={jet}></SvgIcon>
              <JetSpan>{jet}</JetSpan>
            </JetContent>
          );
        })}
      </JetTypeContainer>
      <LinkBox>
        <P>Learn more about private jets, from light to ultra-long range.</P>
        <Link href="/charterQuote" $weight={600}>
          Book Your Private Jet
        </Link>
      </LinkBox>
    </IntroduceContainer>
  );
};

export default Introduce;
